import { SupportedLanguage } from "./languages";

export const APP_STORE_URLS: Record<SupportedLanguage, string> = {
  en: "https://apps.apple.com/us/app/public-speaking-coach-babli/id6746377369",
  es: "https://apps.apple.com/mx/app/hablar-en-p%C3%BAblico-ia-babli/id6746377369",
  fr: "https://apps.apple.com/fr/app/parler-en-public-ia-babli/id6746377369",
  de: "https://apps.apple.com/de/app/rhetorik-sprechcoach-babli/id6746377369",
  ja: "https://apps.apple.com/jp/app/%E3%82%B9%E3%83%94%E3%83%BC%E3%83%81-%E8%A9%B1%E3%81%97%E6%96%B9-%E3%81%82%E3%81%8C%E3%82%8A%E7%97%87%E5%85%8B%E6%9C%8D-babli/id6746377369",
  pl: "https://apps.apple.com/pl/app/trener-mowy-ai-babli/id6746377369?l=pl",
  pt: "https://apps.apple.com/br/app/falar-em-p%C3%BAblico-ia-babli/id6746377369",
};

export const APP_NAMES: Record<SupportedLanguage, string> = {
  en: "Public Speaking Coach: Babli",
  es: "Hablar en Público IA: Babli",
  fr: "Parler en public IA: Babli",
  de: "Rhetorik & Sprechcoach: Babli",
  ja: "スピーチ・話し方・あがり症克服：Babli",
  pl: "Trener mowy AI: Babli",
  pt: "Falar em Público IA: Babli",
};

export const APP_SUBTITLES: Record<SupportedLanguage, string> = {
  en: "Public Speaking Practice",
  es: "Practica Oratoria y Discurso",
  fr: "Discours, Prise de parole",
  de: "Besser vor Publikum sprechen",
  ja: "スピーチ・話し方の練習",
  pl: "Retoryka, komunikacja, głos",
  pt: "Pratique Oratória e Discurso",
};

export const getAppStoreUrl = (language: SupportedLanguage): string =>
  APP_STORE_URLS[language];
